export default {
  aggregates: {
    aggregated: 'Združeni rezultati',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'pre',
    from: 'od',
    since: 'od',
    unit: {
      DAY: 'dan|dani',
      MONTH: 'mesec|meseci',
      YEAR: 'godina|godine'
    },
    untilNow: 'do sada'
  },
  categoryDetails: {
    average: 'Prosečna vrednost je {average}. {benchmark}',
    chartLabel: {
      noLabel: 'Ne',
      yesLabel: 'Da'
    },
    description:
      'Ovo pokazuje kako su odgovori tima na sva pitanja u kategoriji raspoređeni.',
    hideOwnAnswers: 'Sakrij svoje odgovore',
    noResponses: 'Nema odgovora',
    notParticipating: 'Ti nisi odgovorio/la na ova pitanja.',
    numberOfPeople: 'Ispitanici',
    sensitiveQuestion: 'Vidljivo samo tebi kao menadžeru.',
    showFollowUpQuestions: 'Pokaži dodatna pitanja',
    toggleButton: {
      overview: 'Pregled',
      questions: 'Pitanja'
    },
    tooltip: {
      barValue: 'niko | {count} osoba| {count} ljudi',
      barValueAnswers: 'ni jedan | {count} odgovor | {count} odgovora'
    },
    workWith: 'Kako se radi sa {categoryName}',
    yourResponse: 'Tvoj odgovor:'
  },
  error: {
    couldNotLoadAggregates: 'Nije bilo moguće učitati združene rezultate.',
    couldNotLoadResults: 'Nije bilo moguće učitati rezultate.',
    networkError:
      'Došlo je do problema sa učitavanjem podataka sa Interneta. Da li imaš vezu koja radi?',
    unknown: 'Došlo je do nepoznate greške'
  },
  errors: {
    status: {
      BadRequest: 'Loš zahtev za server',
      Forbidden: 'Nije dozvoljeno pristupiti ovom resursu',
      InternalServerError:
        'Došlo je do greške na serveru, kontaktirajte podršku ako se ovo nastavi',
      NotFound: 'Nismo mogli da pronađete ono što tražite',
      Unauthorized: 'Nemate dozvolu za pristup ovom resursu',
      UnknownError: 'Došlo je do nepoznate greške'
    }
  },
  freetext: {
    loadResponses: 'Učitaj odgovore',
    noFreeTextQuestions:
      'Kada u anketi imate pitanja sa slobodnim tekstom, moći ćete da vidite sve odgovore ovde.',
    notEnoughResponses: 'Nema dovoljno odgovora.',
    responses: 'Nema odgovora|{count} odgovor | {count} odgovora'
  },
  general: {
    add: 'Dodaj',
    cancel: 'Otkaži',
    entireOrganization: 'Cela organizacija',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} je prosečna vrednost za pitanja u okviru {title}. {compareToBenchmark}',
    currentValue: 'Trenutna vrednost',
    filter: {
      findGroups: 'Pronađi grupe',
      shouldExportWithHierarchy: 'Uključi osnovne grupe'
    },
    loadMore: 'Učitaj još',
    loadMoreInGroup: 'Učitaj još u okviru {groupName}',
    noone: 'Niko nije odgovorio',
    noResults:
      'Još uvek nema dovoljno odgovora za ovu grupu. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'je odgovorilo',
    nps: 'Merenje lojalnosti (Net Promoter Score)',
    nps_detractors: 'Negativni odgovori',
    nps_passives: 'Pasivni odgovori',
    nps_promoters: 'Pozitivni odgovori',
    questions: 'Pitanja u kategoriji',
    showTrend: 'Prikaži promenu',
    violationsIn:
      'Postoje izveštaji da je došlo do prekršaja u okviru grupe {groupName}. Kontaktiraj odeljenje HR-a koje će te više uputiti i pomoći ti da napreduješ u rešavanju problema.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Izaberite datum kao početnu tačku za istoriju.',
      selectDate: 'Treba da se prikaže istorija anketa od {date}.',
      selectedDate: 'Prikazuje se istorija anketa od {date}.'
    },
    selectorOptions: {
      custom: 'prilagođeno',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Pokušaj ponovo'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Tekuće ankete',
    help: 'Pomoć',
    myActivities: 'Radnje',
    ourResults: 'Rezultati',
    overview: 'Pregled',
    team: 'Tim',
    welcome: 'Dobro došli'
  },
  page: {
    results: 'Svi rezultati'
  },
  resultDetails: {
    backToResults: 'Idi nazad',
    exportData: 'Izvezi',
    exportModal: {
      includeSensitiveQuestions: 'Obuhvati osetljiva pitanja',
      loadingMessage:
        'Podaci se pripremaju za izvoz, ovo može malo da potraje.',
      saveAsExcelAllGroupsDescription:
        'Izvozom u Excel dobićete datoteku sa rezultatima za {groupTitle} i sve osnovne grupe. Ovo je dobro ako želite da uradite sopstvenu analizu ili proračune više grupa.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Izvozom u Excel dobićete datoteku sa rezultatima za {groupTitle}{segmentInfo}. Ovo je dobro ako želite da uradite sopstvenu analizu ili proračune.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Dobićete PDF dokument sa rezultatima za sve kategorije i pitanjima za izabranu grupu. Korisno kada želite da odštampate rezultate.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Izvoz u PowerPoint će vam dati lepu prezentaciju sa rezultatima za {groupTitle}{segmentInfo}. Savršeno kada treba da prikažete rezultate drugima na velikom ekranu.'
    },
    notes: {
      draggable: {
        explanation: 'Vidljivo sam vama.',
        placeholder:
          'Ovde napišite svoje beleške, komentare i razmišljanja o anketi',
        title: 'Lične beleške'
      },
      status: {
        initial: 'Automatsko čuvanje dok kucate',
        saved: 'Promene su sačuvane!',
        unsaved: 'Sačuvaćemo uskoro...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Nema dovoljno odgovora za prikaz rezultata po korisniku'
        },
        description: {
          high: 'Jedna osoba koja je odgovorila, tako da je njen prosečan rezultat postao zelen.|Odgovorilo je {count} osoba, tako da je njihov prosečan rezultat postao zelen.',
          low: 'Jedna osoba koja je odgovorila, tako da je njen prosečan rezultat postao crven.|Odgovorilo je {count} osoba, tako da je njihov prosečan rezultat postao crven.',
          medium:
            'Jedna osoba koja je odgovorila, tako da je njen prosečan rezultat postao žut.|Odgovorilo je {count} osoba, tako da je njihov prosečan rezultat postao žut.'
        },
        title: 'Ni jedna|Jedna osoba|{count} osoba'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Tvoj rezultat je isti kao Pulsᐩ benchmark® za {title}.',
        higherThanBenchmarkValue:
          'Tvoj rezultat je za {benchmarkDiff} viši u odnosu na Pulsᐩ benchmark® za {title}, što je {benchmarkValue}. Lepo!',
        lowerThanBenchmarkValue:
          'Ti si za {benchmarkDiff} niži u odnosu na Pulsᐩ benchmark® za {title}, što je {benchmarkValue}',
        percentagePoints: 'procentni poeni'
      },
      enps: {
        button: {
          description:
            'Usmerićemo te na našeg partnera, EQI, koji sakuplja benčmarking podatke za veliki broj organizacija i pruža detaljniji uvid u tvoj eNPS rezultat.',
          title: 'Uporedi svoj eNPS rezultat sa drugim organizacijama'
        }
      },
      toggleButton: {
        history: 'Istorija',
        overview: 'Pregled'
      }
    }
  },
  results: {
    aggregated: 'Zbirno',
    chooseSurvey: 'Izaberi anketu',
    finished: 'Završeno',
    published: 'U toku'
  },
  resultsmessages: {
    disclaimer:
      'Pulsᐩ AI koristi generativnu veštačku inteligenciju i može da pogreši.',
    error: {
      generic:
        'Uh,... nešto ne funkcioniše kako se očekuje. Pokušajte da učitate stranicu.',
      notEnoughResults:
        'Nema rezultata koji mogu biti tema razgovora. Izaberite drugu grupu ili anketu da biste koristili Pulsᐩ AI.'
    },
    moreInfo: 'Nauči kako da koristiš Pulsᐩ AI kao lider',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Postavite pitanje o rezultatima...',
    reload: 'Ponovo učitaj stranicu',
    report: 'Prijavi problem',
    send: 'Pošalji',
    suggestionHeader: 'Evo nekoliko predloga za pitanja koja možete postaviti:',
    suggestions: {
      groupsComparison: {
        1: 'Na koje grupe treba da se fokusiram?',
        2: 'Postoji li pitanje na kojem bi većina grupa trebalo da radi?',
        3: 'Koje grupe pokazuju negativne trendove?',
        4: 'Koje grupe imaju pozitivne trendove?',
        5: 'Koje grupe se negativno ističu?',
        6: 'Kojim grupama je potrebna moja pažnja?',
        7: 'Šta da uradim prvo?'
      },
      overview: {
        1: 'Šta da radim sa našim rezultatom?',
        2: 'Kako da ovo predstavim svom timu?',
        3: 'Sve u svemu, kako izgledaju rezultati?',
        4: 'Koje su top 3 akcije koje bismo trebali preduzeti?',
        5: 'Šta mogu poboljšati u svom rukovodstvu?',
        6: 'Koje rizike imamo?',
        7: 'Šta bi se moglo dogoditi ako ne delujemo?',
        8: 'Čemu treba dati prioritet?',
        9: 'Koja je prognoza za moj tim?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Svi'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Uporedi'
        },
        export: {
          title: 'Izvezi'
        },
        freetext: {
          title: 'Slobodan tekst'
        },
        results: {
          title: 'Rezultati ankete'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Nije moguće pokazati statistiku bez rizika od gubitka anonimnosti.',
    others: 'Drugo | Drugi',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administracija',
    currentSurveys: 'Trenutne ankete',
    dashboard: 'Kontrolna tabla',
    help: 'Pomoć',
    logOut: 'Odjava',
    myActivities: 'Moje radnje',
    ourResults: 'Naši rezultati'
  },
  topbanner: {
    preview: {
      body: 'Sada gledate novu verziju Pulsᐩ rezultata koja ima mnoga poboljšanja! Ako naiđete na nešto što ne funkcioniše kako bi trebalo ili ako imate povratne informacije, javite nam! Takođe možete da se vratite na staru verziju ako želite.',
      header: 'Nova verzija!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Tokom vremenskog perioda {startDate} - {endDate} rezultat je smanjen za {categoryName}.',
        trend_increased:
          'Tokom vremenskog perioda {startDate} - {endDate} rezultat je povećan za {CategoryName}. Nastavite sa dobrim radom!',
        trend_same:
          'Rezultat je ostao isti za {CategoryName} tokom vremenskog perioda {startDate} - {endDate}.'
      }
    },
    noTrend: 'Nema starije ankete za upoređivanje.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'U poređenju sa prethodnom anketom od {oldSurveyDate}, rezultat se smanjio za {changeInPercent}% za {tagName}.',
        nps_trend_increased:
          'U poređenju sa prethodnom anketom od {oldSurveyDate}, rezultat se povećao za {changeInPercent}% za {tagName}.',
        nps_trend_same:
          'Rezultat je otprilike ostao isti ({changeInPercent}% promene) za {tagName} od poslednje ankete od {oldSurveyDate}.',
        trend_decreased:
          'Tokom vremenskog perioda {startDate} - {endDate} rezultat je smanjen za {tagName}.',
        trend_increased:
          'Tokom vremenskog perioda {startDate} - {endDate} rezultat je povećan za {tagName}',
        trend_same:
          'Rezultat je ostao isti za {CategoryName} tokom vremenskog perioda {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Sve grupe',
    cannotChangeGroupsWhileComparing:
      'Dok ste u prikazu poređenja, gledate više grupa istovremeno.',
    group: 'Grupa',
    segment: 'Segment',
    survey: 'Anketa'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Broj ljudi koji su izabrali bar jednu radnju',
      totalActions: 'Ukupan broj izabranih radnji'
    },
    title: 'Rezime radnji'
  },
  widgetAlert: {
    actions: {
      saved: 'Hvala, aktivnost je sačuvana.'
    },
    links: {
      tooltip: 'Veza se otvara u novom prozoru'
    },
    notEnoughData: 'Ovde trenutno nema ničega za prikaz.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Poslednje prijavljeno {surveyDate}.'
      },
      question: {
        info: 'Poslednje pitanje postavljeno {surveyDate} u „{surveyTitle}“.'
      }
    },
    notEnoughResponses:
      'Još uvek nema dovoljno odgovora da bismo ovde bilo šta prikazali.',
    title: 'Kategorije',
    tooltip: {
      value:
        'Ovo je prosečna vrednost za sve odgovore na piranja u okviru {categoryName} na koje su odgovorili ljudi iz grupe {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Došlo je do neočekivane greške prilikom pokušaja učitavanja vidžeta. Prvo pokušajte da ponovo učitate stranicu. Ako se problem i dalje javlja, prijavite nam ga i mi ćemo ga odmah pogledati!',
    hideErrorDetails: 'Sakrij detalje o grešci',
    showErrorDetails: 'Prikaži detalje o grešci',
    title: 'Problem u vidžetu!'
  },
  widgetGroupActions: {
    allCategories: 'U okviru svih kategorija',
    freeText: {
      alert: {
        noResults: 'Ništa nije pronađeno. Pokušaj da otkucaš nešto drugo.',
        typeMore: 'Otkucaj još nešto'
      },
      filterField: {
        placeholder: 'Kucaj za pronalaženje komentara'
      },
      numberOfComments: '{numberOfComments} komentara'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Kako razviti ličnu odgovornost među zaposlenima'
      }
    },
    noActions: 'Nema radnji za prikaz.',
    noActionsSelectedInCategory: 'Nema izabranih radnji',
    otherActions: 'Sopstvene radnje',
    people: 'niko | {count} osoba| {count} ljudi',
    peopleSelectedActions:
      'Od ukupno {peopleResponded} osoba koje su se odazvale, samo 1 je izabrala najmanje jednu radnju ({percentage}%)| Od ukupno {peopleResponded} osoba koje su se odazvale, {count} osoba izabralo je najmanje jednu radnju ({percentage}%)',
    title: 'Izabrane radnje za osobe iz grupe {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 osoba je izabrala ovu radnju| {count} osoba je izabralo ovu radnju'
    }
  },
  widgetGroupPriorities: {
    description:
      'Ovo su najvažnije oblasti na koje se sada treba usredsrediti, prema mišljenju učesnika ankete.',
    freeTextResponses: 'Pokaži odgovore u slobodnom tekstu',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Kako razviti svoj tim pomoću Pulsᐩ'
      }
    },
    noPriorities: 'Nema prioriteta koje su učesnici izabrali.',
    people: 'niko | {count} osoba| {count} ljudi',
    thinkImportant: ' misli da je „{category}” najvažnija',
    title: 'Prioriteti za ljude iz grupe {groupName}'
  },
  widgetNotImplemented: {
    content: 'Još uvek nije primenjeno'
  },
  widgetSurveyInfo: {
    endDate: 'Datum završetka:',
    noone: 'Niko nije odgovorio',
    notEnoughResponses: {
      aggregate:
        'Nije dovoljno ljudi odgovorilo u datom vremenskom periodu da bi se prikazali rezultati.',
      completed:
        'Nije dovoljno ljudi odgovorilo na anketu da bi se prikazali rezultati.',
      published:
        'Još uvek nije dovoljno ljudi odgovorilo na anketu da bi se prikazali rezultati.'
    },
    participation: {
      title: 'Učešće'
    },
    startDate: 'Datum početka:',
    status: {
      completed: 'Anketa je završena! Ovo su konačni rezultati.',
      published: 'Anketa je još uvek aktuelna. Rezultati su preliminarni.'
    },
    usersInvited: 'Ljudi pozvano:',
    usersResponded: 'Ljudi se odazvalo:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Ovo su najnoviji rezultati za {groupName}.'
    },
    notEnoughResponses:
      'Još uvek nema dovoljno odgovora da bismo ovde bilo šta prikazali.',
    title: {
      company: 'Svi iz organizacije {organizationName}'
    },
    tooltip: {
      enps_description:
        "eNPS označava 'Employee Net Promoter Score' (merenje lojalnosti zaposlenih) i meri koliko su zaposleni spremni da preporuče zaposlenje u svojoj kompaniji.",
      nps_description:
        "NPS označava 'Net Promoter Score' (merenje lojalnosti) i predstavlja merenje verovatnoće da će ljudi nešto preporučiti drugima.",
      nps_detractors: 'Negativni odgovori',
      nps_passives: 'Pasivni odgovori',
      nps_promoters: 'Pozitivni odgovori',
      value:
        'Ovo je prosečna vrednost svih odgovora na pitanja u {tagName} na koje su odgovorili ljudi iz grupe {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} tokom vremena',
    twoTags: '{tag1} i {tag2}'
  }
}
